import { FileType } from "../fileConfig";
import { ImagePreview } from "./ImagePreview";
import { IPreviewComponent } from "./types";

export const PREVIEW_COMPONENTS: Partial<Record<FileType, IPreviewComponent>> = {
	image: {
		component: ImagePreview,
	},
};

export const getPreviewComponent = (fileType: FileType): IPreviewComponent | null => {
	return PREVIEW_COMPONENTS[fileType] || null;
};
